export default __webpack_public_path__ + "OpenSans_Condensed-ExtraBold.ttf";